(function () {
	const { reveal, conceal } = window.AccordionPanel;

	const closeItem = (activeItem) => {
		const activeToggle = activeItem.querySelector(".collapsible-content__toggle");
		const activePanel =
			activeToggle &&
			document.getElementById(activeToggle.getAttribute("aria-controls"));

		activeItem.classList.remove("active");
		if (activeToggle) {
			activeToggle.setAttribute("aria-expanded", "false");
		}
		conceal(activePanel);
	};

	const toggleItem = (toggle) => {
		const item = toggle.closest(".collapsible-content__item");
		const items = item.closest(".collapsible-content__items");
		const panel = document.getElementById(toggle.getAttribute("aria-controls"));
		const isExpanded = toggle.getAttribute("aria-expanded") === "true";

		if (!isExpanded) {
			items
				.querySelectorAll(".collapsible-content__item.active")
				.forEach(closeItem);

			toggle.setAttribute("aria-expanded", "true");
			reveal(panel, () => {
				item.classList.add("active");
			});
		} else {
			item.classList.remove("active");
			toggle.setAttribute("aria-expanded", "false");
			conceal(panel);
		}
	};

	const initCollapsibleContent = () => {
		document.querySelectorAll(".collapsible-content__toggle").forEach((toggle) => {
			if (toggle.dataset.a11yInit) return;
			toggle.dataset.a11yInit = "true";
			toggle.addEventListener("click", () => toggleItem(toggle));
		});
	};

	document.addEventListener("shopify:section:load", initCollapsibleContent);
	initCollapsibleContent();
})();
